module.exports = __webpack_public_path__ + "img/ep2.b4199e90.jpg";